import { useEffect, useState } from "react";
import { ClientService } from "../../component/services/client.service";
import { Card, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { makeParams } from "../../component/api/makeRequest";

export default function VendorOverView() {

    const [vendorStats, setVendorStats] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<Date>(moment().startOf('day').toDate());
    const [endDate, setEndDate] = useState<Date>(moment().endOf('day').toDate());

    async function getVendorStats(start: Date, end: Date) {
        const params = makeParams([
            { index: "start_time", value: moment(start).toISOString() },
            { index: "end_time", value: moment(end).toISOString() },
        ])
        await ClientService.getVendorReverficationStats(params)
            .then((res: any) => {
                setVendorStats(res.data?.data || []);
            })
            .catch((err: any) => {
                console.log(err);
            });
    }

    useEffect(() => {
        getVendorStats(startDate, endDate);
    }, []);

    function handleStartDate(date: Date | null) {
        if (!date) {
            return;
        };
        const start = moment(date).startOf('day').toDate();
        setStartDate(start);
        getVendorStats(start, endDate);
    }

    function handleEndDate(date: Date | null) {
        if (!date) return;
        const end = moment(date).endOf('day').toDate();
        setEndDate(end);
        getVendorStats(startDate, end);
    }

    return (
        <>
            <Card className="mt-4 mb-5 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                <Card.Body className="p-4">
                    <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
                        <p className="mb-0 fw-semibold">Vendor Reverification Stats</p>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                            <div className="d-flex align-items-center gap-1">
                                <label className="text-muted small mb-0" style={{ whiteSpace: "nowrap" }}>From</label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleStartDate}
                                    selectsStart
                                    startDate={startDate}
                                    endDate={endDate}
                                    maxDate={endDate}
                                    dateFormat="dd MMM yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <label className="text-muted small mb-0" style={{ whiteSpace: "nowrap" }}>To</label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={handleEndDate}
                                    selectsEnd
                                    startDate={startDate}
                                    endDate={endDate}
                                    minDate={startDate}
                                    maxDate={moment().endOf('day').toDate()}
                                    dateFormat="dd MMM yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>
                    </div>

                    <Table striped hover responsive>
                        <thead>
                            <tr>
                                <th>Vendor Name</th>
                                <th>Total Registered</th>
                                <th>Total Reverifications</th>
                                <th>Total Success</th>
                                <th>Total Failure</th>
                                <th>Distinct Success</th>
                                <th>Distinct Failure</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendorStats.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="text-center text-muted py-4">
                                        No data found for the selected range
                                    </td>
                                </tr>
                            ) : (
                                vendorStats.map((vendor: any, index: number) => (
                                    <tr key={vendor._id}>
                                        <td>{vendor.vendorName}</td>
                                        <td>{vendor.totalRegistered}</td>
                                        <td>{vendor.totalReverification}</td>
                                        <td>{vendor.totalSuccessReverification}</td>
                                        <td>{vendor.totalFailureReverification}</td>
                                        <td>{vendor.distinctSuccessStudents}</td>
                                        <td>{vendor.failedDistinctStudents}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
}